import { z } from 'zod';

export const WalletsApproveResponseSchema = z.object({
  data: z
    .object({
      message: z.string(),
    })
    .default({ message: '' }),
});

export type TWalletsApproveDataResponse = z.infer<typeof WalletsApproveResponseSchema>;
export type TWalletsApproveData = TWalletsApproveDataResponse['data'];
